import {
  Box,
  Flex,
  Heading,
  Link,
  Card,
  CardBody,
  Grid,
} from "@chakra-ui/react"
import { EducationMeter } from "../features/game/EducationMeter"
import SlideViewer from "../features/game/SlideViewer"
import { CharacterAvatar } from "../features/character/CharacterAvatar"
import { useAvatarEditorModal } from "../features/character/useAvatarEditorModal"
import { MentalHealthMeter } from "../features/game/MentalHealthMeter"
import { PhysicalHealthMeter } from "../features/game/PhysicalHealthMeter"

const GameSlidePage: React.FC = () => {
  const { openModal } = useAvatarEditorModal()

  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-br, #7c3aed, #5b4dd6)"
      p={{ base: 4, md: 6, lg: 8 }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        direction={{ base: "column", lg: "row" }}
        gap={{ base: 4, lg: 6 }}
        maxW="1600px"
        w="100%"
        alignItems={{ base: "center", lg: "flex-start" }}
        justifyContent="center"
      >
        {/* Main Card - Meters and Slide */}
        <Card
          bg="white"
          borderRadius="3xl"
          boxShadow="2xl"
          w="100%"
          maxW={{ base: "100%", lg: "900px" }}
          overflow="hidden"
        >
          <CardBody p={{ base: 6, md: 8 }}>
            {/* Title */}
            <Heading
              as="h1"
              size={{ base: "lg", md: "xl" }}
              textAlign="center"
              color="purple.700"
              mb={6}
            >
              My Future, My Choice
            </Heading>

            {/* Meters - Horizontal Row */}
            <Grid
              templateColumns={{ base: "repeat(1, 1fr)", sm: "repeat(3, 1fr)" }}
              gap={4}
              mb={6}
              px={{ base: 0, md: 4 }}
            >
              <Box>
                <PhysicalHealthMeter />
              </Box>
              <Box>
                <MentalHealthMeter />
              </Box>
              <Box>
                <EducationMeter />
              </Box>
            </Grid>

            {/* Slide Viewer */}
            <Box>
              <SlideViewer />
            </Box>
          </CardBody>
        </Card>

        {/* Character Avatar Card - Side by side on desktop, below on mobile */}
        <Card
          bg="white"
          borderRadius="2xl"
          boxShadow="2xl"
          w="100%"
          maxW={{ base: "100%", sm: "420px", lg: "420px" }}
          alignSelf={{ base: "center", lg: "flex-start" }}
          flexShrink={0}
        >
          <CardBody p={{ base: 4, md: 6 }}>
            <Link onClick={openModal} cursor="pointer">
              <CharacterAvatar />
            </Link>
          </CardBody>
        </Card>
      </Flex>
    </Box>
  )
}

export default GameSlidePage
